/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import { sanitize } from 'cio/utils/sanitize';
import { config } from 'cio/helpers/preview-whitelist';

interface IframeArgs {
  body: string;
}

export default class Iframe extends Component<IframeArgs> {
  @tracked element!: HTMLIFrameElement;

  willDestroy() {
    super.willDestroy();
    if (!this.isDestroyed && !this.isDestroying) {
      this.element.removeEventListener('load', this.applyBodyToIframe);
    }
  }

  @action
  applyBodyToIframe() {
    if (isPresent(this.args.body)) {
      let { contentDocument } = this.element;
      if (contentDocument != null) {
        let body = sanitize(this.args.body, config);
        contentDocument.body.innerHTML = body;

        // Force all links to open in new tab
        Array.from(contentDocument.links).forEach((link) => {
          link.target = '_blank';
          // eslint-disable-next-line spellcheck/spell-checker
          link.rel = 'noopener noreferrer';
        });
      }
    }
  }

  @action
  onInsert(element: HTMLIFrameElement) {
    this.element = element;
    this.applyBodyToIframe();

    // Setting the content of the iframe too early disappears in firefox,
    // so do it again when the iframe is loaded
    this.element.addEventListener('load', this.applyBodyToIframe);
  }
}
